"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactTransitionGroup = require("react-transition-group");

var _scrollIntoViewIfNeeded = _interopRequireDefault(require("scroll-into-view-if-needed"));

var _A11yContext = require("../../context/A11yContext");

var _Comment = _interopRequireDefault(require("../Comment/Comment"));

var _CommentsEmptyState = _interopRequireDefault(require("../EmptyState/CommentsEmptyState"));

var _DisabledCreationEmptyState = _interopRequireDefault(require("../EmptyState/DisabledCreationEmptyState"));

var _NodeEmptyState = _interopRequireDefault(require("../EmptyState/NodeEmptyState"));

var _FilterEmptyState = _interopRequireDefault(require("../EmptyState/FilterEmptyState"));

var _useIngest = _interopRequireDefault(require("../../hooks/useIngest"));

var _constants = require("../../constants");

var _BaseCommentList = _interopRequireDefault(require("./BaseCommentList.scss"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var BaseCommentList = /*#__PURE__*/(0, _react.memo)(function (props) {
  var ariaLabelledBy = props.ariaLabelledBy,
      assetData = props.assetData,
      cacheComments = props.cacheComments,
      closeButtonClicked = props.closeButtonClicked,
      comments = props.comments,
      compactLayout = props.compactLayout,
      emptyStateType = props.emptyStateType,
      filter = props.filter,
      imsData = props.imsData,
      isFiltered = props.isFiltered,
      isOffline = props.isOffline,
      onHeightChange = props.onHeightChange,
      onShare = props.onShare,
      touchControls = props.touchControls;
  var ccxIngest = (0, _useIngest.default)();
  (0, _react.useEffect)(function () {
    if (filter === 'resolved') {
      ccxIngest.fireEvent({
        event: {
          subcategory: 'resolve',
          subtype: 'resolved-comments',
          type: 'render'
        }
      });
    }
  }, [ccxIngest, filter]);
  var commentRefs = (0, _react.useMemo)(function () {
    return comments.reduce(function (refs, comment) {
      refs[comment.id] = /*#__PURE__*/_react.default.createRef();
      return refs;
    }, {});
  }, [comments]);
  var handleScrollToComment = (0, _react.useCallback)(function (commentId) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
      behavior: 'smooth',
      block: 'center'
    };
    var commentRef = commentRefs[commentId];

    if (commentRef && commentRef.current) {
      (0, _scrollIntoViewIfNeeded.default)(commentRef.current, _objectSpread(_objectSpread({}, options), {}, {
        scrollMode: 'if-needed',
        boundary: document.getElementById(_constants.LIST_COMPONENT_ID)
      }));
    }
  }, [commentRefs]);
  var emptyState;

  switch (emptyStateType) {
    case 'disabledCommentCreation':
      emptyState = /*#__PURE__*/_react.default.createElement(_DisabledCreationEmptyState.default, null);
      break;

    case 'global':
      emptyState = /*#__PURE__*/_react.default.createElement(_NodeEmptyState.default, null);
      break;

    default:
      emptyState = /*#__PURE__*/_react.default.createElement(_CommentsEmptyState.default, {
        onShare: onShare
      });
  }

  return /*#__PURE__*/_react.default.createElement(_A11yContext.A11yProvider, null, /*#__PURE__*/_react.default.createElement(_reactTransitionGroup.TransitionGroup, {
    "aria-labelledby": ariaLabelledBy,
    role: "list",
    className: _BaseCommentList.default.component,
    component: "ul",
    "data-testid": "comment-list"
  }, comments.length === 0 ? /*#__PURE__*/_react.default.createElement(_reactTransitionGroup.CSSTransition, {
    timeout: 0,
    exit: false
  }, isFiltered ? /*#__PURE__*/_react.default.createElement(_FilterEmptyState.default, {
    allScreenCommentsOn: emptyStateType === 'global'
  }) : emptyState) : comments.map(function (comment) {
    var newComment = comment.recentActivity === _constants.JUST_ADDED;
    return /*#__PURE__*/_react.default.createElement(_reactTransitionGroup.CSSTransition, {
      key: comment.id,
      classNames: "fade",
      timeout: 500,
      onEnter: newComment ? function () {
        return handleScrollToComment(comment.id, {
          behavior: 'auto'
        });
      } : undefined,
      enter: !isFiltered,
      exit: false
    }, /*#__PURE__*/_react.default.createElement(_Comment.default, {
      ref: commentRefs[comment.id],
      assetData: assetData,
      cacheComments: cacheComments,
      ccxIngest: ccxIngest,
      closeButtonClicked: closeButtonClicked,
      comment: comment,
      compactLayout: compactLayout,
      imsData: imsData,
      isOffline: isOffline,
      onHeightChange: onHeightChange,
      onScrollToComment: handleScrollToComment,
      touchControls: touchControls
    }));
  })));
});
BaseCommentList.displayName = 'BaseCommentList';
BaseCommentList.propTypes = {
  ariaLabelledBy: _propTypes.default.string,
  assetData: _propTypes.default.object,
  cacheComments: _propTypes.default.bool,
  closeButtonClicked: _propTypes.default.bool,
  comments: _propTypes.default.array,
  compactLayout: _propTypes.default.bool,
  emptyStateType: _propTypes.default.string,
  filter: _propTypes.default.string,
  imsData: _propTypes.default.object,
  isFiltered: _propTypes.default.bool,
  isOffline: _propTypes.default.bool,
  onHeightChange: _propTypes.default.func,
  onShare: _propTypes.default.func,
  touchControls: _propTypes.default.bool
};
var _default = BaseCommentList;
exports.default = _default;